import { postJson } from '@/utils/fetchOptions';
import { useMutation } from '@tanstack/react-query';
import { logout } from '@/utils/auth';
import { message } from 'antd/lib';
import { useTranslation } from 'react-i18next';
import { useAuthToken } from '../useAuth';

interface DraftResponseType {
  draft: Api.Influencer.Draft;
  code: string;
}

export function useDraftSubmit({
  draftId,
  onSuccess
}: {
  draftId: string;
  onSuccess?: (data: DraftResponseType | ResponseObject) => void;
}) {
  const token = useAuthToken();
  const { t } = useTranslation();

  const draftMutation = useMutation({
    mutationKey: ['submit-draft', draftId],
    mutationFn: async () => {
      return postJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/influencer/draft/${draftId}/submit`,
        body: { draftId },
        token
      }).then((response: DraftResponseType | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response && response.code !== 'DRAFT_SUBMITTED_FOR_REVIEW') {
          message.success(t(`alert.${response.code}`));
        }

        return response;
      });
    },
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data);
      }
    }
  });

  const submitDraft = async () => {
    await draftMutation.mutateAsync();
  };

  return {
    submitDraft,
    isLoading: draftMutation.isLoading,
    error: draftMutation.error,
    isSuccess: draftMutation.isSuccess
  };
}
